// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ea84af86","453":"fa7d0102","455":"8fc90c62","977":"5561e114"}[chunkId] + ".chunk.js";
};